/* unplugin-vue-components disabled */import { render } from "./collapsible-headings.vue?vue&type=template&id=c9446666&scoped=true"
import script from "./collapsible-headings.vue?vue&type=script&lang=js"
export * from "./collapsible-headings.vue?vue&type=script&lang=js"

import "./collapsible-headings.vue?vue&type=style&index=0&id=c9446666&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9446666"],['__file',"src/components/md-content-v2/collapsible-headings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9446666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9446666', __exports__)) {
    api.reload('c9446666', __exports__)
  }
  
  module.hot.accept("./collapsible-headings.vue?vue&type=template&id=c9446666&scoped=true", () => {
    api.rerender('c9446666', render)
  })

}


export default __exports__